import { render, staticRenderFns } from "./WaitingOrder.vue?vue&type=template&id=889f0790&scoped=true"
import script from "./WaitingOrder.vue?vue&type=script&lang=js"
export * from "./WaitingOrder.vue?vue&type=script&lang=js"
import style0 from "./WaitingOrder.vue?vue&type=style&index=0&id=889f0790&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "889f0790",
  null
  
)

export default component.exports